import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import {Theme} from '@mui/material';

import {clearLoginError, login} from '../../store/actions';
import {
    portalLoginLogoHeightSelector,
    portalLoginLogoSelector
} from '../../store/selectors';

import {LoginForm} from '../../components/login';
import FooterLinksSection from "../../components/common/FooterLinksSection";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    grow: {
        flexGrow: 1,
        minHeight: theme.spacing(2)
    },
    content: {
        width: '100%',
        maxWidth: '388px',
        padding: `0 ${theme.spacing(2)}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        boxSizing: 'border-box'
    },
    error: {
        marginBottom: theme.spacing(3)
    },
    logo: {
        marginBottom: theme.spacing(6)
    }
}));

const LoginPage = (): React.ReactElement => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const logo = useSelector(portalLoginLogoSelector);
    const logoHeight = useSelector(portalLoginLogoHeightSelector);

    useEffect(() => {
        dispatch(clearLoginError());
    }, []);

    const onLogin = useCallback(
        ({email, password, rememberUser}: { email: string; password: string, rememberUser: boolean }) => {
            dispatch(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                login({
                    email,
                    password
                })
            );
        },
        []
    );

    const onCloseError = (): void => {
        dispatch(clearLoginError());
    };
    return (
        <div className={classes.container}>
            <div className={classes.grow}/>
            <div className={classes.content}>
                <img
                    className={classes.logo}
                    alt="troy"
                    src={logo}
                    height={logoHeight}
                />
                <LoginForm onSubmit={onLogin}/>
            </div>
            <div className={classes.grow}/>
            <FooterLinksSection/>
        </div>
    );
};

export default LoginPage;
